import { ConfigStore } from "../../store/modules/config";
import { AppStore } from "../../store/modules/app";
import { Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import i18n from "@/i18n";
import { OperationVue } from "../operations/OperationVue";
import IOperationService from "../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { SMSPacket } from "../../data/smsPacket";
import { ContractSmsModel } from "../../models/contractOperations/ContractSmsModel";
import IAlertService from "../../services/alert/IAlertService";
import { ContractsStore } from "../../store/modules/contracts";

/**
 *  Класс для компоненты смены смс пакета счета.
 */
export class ContractSmsModalVue extends OperationVue {

  /** Входные параметры */
  @Prop() params!: any;

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**
 * Сервис проведения операций каталога
 * @returns {IOperationService}
 */
  get operationService(): IOperationService {
    return container.get<IOperationService>(DiTokens.ContractSmsService);
  }

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище данных пользователя
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**
 * Хранилище данных приложения
 * @returns {AppStore}
 */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }

  /**
 * Код операции
 * @returns {string} - код для отправки апи.
 */
  get respondentCode(): string {
    return this.configStore.apiData.OperationCodeOfChangeSmsPacket;
  }

  /**
 * Заголовок операции
 * @returns {string} - Заголовок операции
 */
  get operTitle(): string {
    return i18n.t("main.contracts.actions.modalTitleSMS").toString();
  }

  /**
 * Набор смс пакетов
 * @returns {Array<SMSPacket>} - масив пакетов
 */
  get commonSmsPackets(): Array<SMSPacket> {
    return this.contractsStore.smsPackets.filter((packet: any) => packet.BankSet != "1" && packet.Vip != 1);
  }

  /**Инициализация формы */
  async init(): Promise<void> {
    await this.initOperation();
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    super.afterExecute();
    const acc = this.contractsStore.contracts.getContractByRefId(this.params.contractId);
    this.appStore.setLoading(true);
    this.contractsStore.updateContract(acc.Data.Id);
    this.appStore.setLoading(false);
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.ContractSmsService);
    const acc = this.contractsStore.contracts.getContractByRefId(this.params.contractId);
    const packet = this.commonSmsPackets.find((pac: any) => pac.Code == acc.Data.SmsPacketId);
    this.OperationModel = (await this.service.init({
      contractId: this.params.contractId,
      code: this.respondentCode,
      packet: packet
    })) as ContractSmsModel;
    this.loading = false;
  }
}
